import cloneDeep from 'lodash/cloneDeep';
import { general } from './general';

export const country = (data = {}) => {
  // Ensure the value is always sent as an array
  let clonedData = cloneDeep((data || {}));
  if (clonedData?.value && !Array.isArray(clonedData.value)) {
    clonedData = {
      ...clonedData,
      value: [clonedData.value],
    };
  } else if (!clonedData?.value) {
    // if for any reason the value is null at this point, then we need to set it to empty array
    clonedData = {
      ...clonedData,
      value: [],
    };
  }
  return general('country', clonedData);
};
